import { useConfigContext } from "@/app";
import { CarouselType } from "@/entities/Carousel";
import { useCarouselStore } from "@/stores/carouselStore";
import { Swiper } from "antd-mobile";
import { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
export const HomeCarousel = () => {
  const {
    carousels = [],
    getCarousels
  } = useCarouselStore();
  const {
    getSourcePath
  } = useConfigContext();
  const navigate = useNavigate();
  useLayoutEffect(() => {
    getCarousels();
  }, []);
  const onClick = (item: CarouselType) => {
    navigate(`/active/${item.id}`);
  };
  return <Swiper autoplay loop autoplayInterval={3000} data-sentry-element="Swiper" data-sentry-component="HomeCarousel" data-sentry-source-file="HomeCarousel.tsx">
        {carousels.map(item => {
      return <Swiper.Item key={item.id} style={{
        height: '100px'
      }} onClick={() => onClick(item)}>
            <img src={getSourcePath(item.imgAddr)} alt={item.title} style={{
          width: '100%',
          height: '100%',
          padding: '0px 14px'
        }} />
          </Swiper.Item>;
    })}
    </Swiper>;
};